export enum AssetTypeTopology {
  TABLE = "AssetType",
  TYPE = "type",
  DELETED_AT = "deletedAt",
}
